import { useState } from "react";

export const useFormProduct = () => {

    const [isEditFormVisible, setIsEditFormVisible] = useState<boolean>(false);
    const [isAddImageVisible, setIsAddImageVisible] = useState<boolean>(false);
    const [isEditDetailsVisible, setIsEditDetailsVisible] = useState<boolean>(false);
    const [isAddDetailsVisible, setIsAddDetailsVisible] = useState<boolean>(false);

    const handlerFormEdit = (action: "open" | "close") => {
        if(isAddImageVisible && isEditDetailsVisible && isAddDetailsVisible) {
            setIsAddImageVisible(false)
            setIsEditDetailsVisible(false)
            setIsAddDetailsVisible(false)
        }

        setIsEditFormVisible(action === "open")
    }

    const handlerFormAddImage = (action: "open" | "close") => {
        if(isEditFormVisible && isEditDetailsVisible && isAddDetailsVisible) {
            setIsEditFormVisible(false)
            setIsEditDetailsVisible(false)
            setIsAddDetailsVisible(false)
        }

        setIsAddImageVisible(action === "open");
    }

    const handlerFormAddDetail = (action: "open" | "close") => {
        if(isAddImageVisible && isEditDetailsVisible && isEditFormVisible) {
            setIsAddImageVisible(false)
            setIsEditDetailsVisible(false)
            setIsEditFormVisible(false)
        }

        setIsAddDetailsVisible(action === "open");
    }

    const handlerFormEditDetail = (action: "open" | "close") => {
        if(isAddImageVisible && isEditFormVisible && isAddDetailsVisible) {
            setIsAddImageVisible(false)
            setIsEditFormVisible(false)
            setIsAddDetailsVisible(false)
        }

        setIsEditDetailsVisible(action === "open")
    }

    return {
        handlerFormEdit,
        handlerFormAddImage,
        handlerFormAddDetail,
        handlerFormEditDetail,

        isEditFormVisible,
        isAddImageVisible,
        isEditDetailsVisible,
        isAddDetailsVisible,
    }
}